"use strict";
var ECalendarMode;
(function (ECalendarMode) {
    ECalendarMode[ECalendarMode["Day"] = 0] = "Day";
    ECalendarMode[ECalendarMode["DayTime"] = 1] = "DayTime";
    ECalendarMode[ECalendarMode["Month"] = 2] = "Month";
    ECalendarMode[ECalendarMode["Time"] = 3] = "Time";
})(ECalendarMode = exports.ECalendarMode || (exports.ECalendarMode = {}));
//# sourceMappingURL=calendar-mode-enum.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/ng2-date-picker/common/types/calendar-mode-enum.js
// module id = ../../../../ng2-date-picker/common/types/calendar-mode-enum.js
// module chunks = vendor